import React, { useContext, useState } from 'react';
import { auth } from "../../config/firebase";
import { DataContext } from '../data/DataContext';
import { DataContextType } from '../data_types/interfaces';
import { Delete } from '@mui/icons-material';
import { Box, Button, Container, Link, TextField, Typography } from '@mui/material';
import LogoutButton from '../buttons/Logout';


const DeletePageBottom = ()=> {
    const context = useContext<DataContextType | undefined>(DataContext);
    const { deletePlayerData, deleteConfirmed, setDeleteConfirmed } = context || {};
    const [inputValue, setInputValue] = useState('');
    const [message, setMessage] = useState('');
    
    const handleDelete = () => {
        if (inputValue === 'DELETE') {
            setMessage('');
            if (setDeleteConfirmed) {
                setDeleteConfirmed(true);
            }
            if (deletePlayerData) {
                deletePlayerData();
            }
            setTimeout(() => {
                auth.signOut().then(() => {
                    sessionStorage.clear();
                    window.location.href = '/';
                });
            }, 5000);
        } else {
            setMessage('Please type DELETE to confirm.');
        }
    };

    if (deleteConfirmed) {
        return (
            <Container component="main" maxWidth="xs">
            <Box
                sx={{
                    marginTop: { xs: 8, sm: 6, md: 10 },
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
                <Typography variant="h6">Your account has been deleted.</Typography>
                <Typography>You will be redirected shortly...</Typography>
            </Box>
            </Container>
        );
    }

    return (
        <Container component="main" maxWidth="sm">
            <Box
                sx={{
                    marginTop: { xs: 4, sm: 3, md: 5 },
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'left',
                    whiteSpace: "pre-wrap",
                }}
            >
                <Typography align='left'>
                    If you're having problems, please contact our <Link href="mailto:support@spinoffgames.se">support</Link> who can help.
                </Typography>
                <Typography align='left'>
                    Deleting your account will remove access to Disc Golf Valley.
                </Typography>
                <Typography align='left'>
                    Account information, purchases, game progress, in-game content will also be permanently deleted.
                </Typography>
                <Typography align='left'>
                    This cannot be undone.
                </Typography>
            </Box>
            <Box
                sx={{
                    marginTop: { xs: 4, sm: 3, md: 5 },
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    whiteSpace: "pre-wrap",
                }}
            >
                <Typography variant="h6" align='center'>To confirm this, type "DELETE"</Typography>
                <TextField fullWidth
                                sx={{
                                    marginTop: 1,
                                }}
                    value={inputValue} 
                    onChange={(e) => setInputValue(e.target.value)} 
                    label="Type DELETE to confirm" 
                />
                <Typography color="error">{message}</Typography>
            </Box>
            <Box
                sx={{
                    marginTop: { xs: 4, sm: 3, md: 5 },
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    whiteSpace: "pre-wrap",
                }}
            >
                <Button fullWidth sx={{ marginBottom: 2 }}size="large" variant="contained" color="error" startIcon={<Delete />} onClick={handleDelete}>
                    Delete Now
                </Button>
                <LogoutButton fullWidth text="Cancel" size="large" />
            </Box>
        </Container>
    );
};

export default DeletePageBottom;
